import { render } from "./PlanCard.vue?vue&type=template&id=439b4e15&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"

import "./PlanCard.vue?vue&type=style&index=0&id=439b4e15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439b4e15"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
